<template>
    <div class="text-muted small mt-1">
      <span :class="{ 'text-danger': isOverLimit }">
        {{ count }}/{{ limit }} {{ label }}
      </span>
      <span v-if="isOverLimit" class="text-danger"> - {{$t('limit-exceeded')}}</span>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      text: {
        type: String,
        required: true
      },
      limit: {
        type: Number,
        required: true,
        default: 100
      },
      mode: {
        type: String,
        default: 'none',
        validator: value => ['words', 'characters', 'none'].includes(value)
      }
    },
    computed: {
      count() {
        if (this.mode === 'words') {
            return this.countWords(this.text)        
        } else if (this.mode === 'characters') {
          return this.countCharacters(this.text)
        } else {
          return 0
        }
      },
      isOverLimit() {
        return this.limit && this.count > this.limit
      },
      label() {
        if (this.mode === 'words') return 'words'
        if (this.mode === 'characters') return 'characters'
        return ''
      }
    },
    methods: {
    stripHtml(html) {
        if (!html) return ''
        
        // Replace block-level tags with spaces (preserves paragraph boundaries)
        let processed = html.replace(/<\/?(p|div|br|h[1-6]|li|tr|td|th)[^>]*>/gi, ' ')
        
        // Remove remaining HTML tags
        processed = processed.replace(/<[^>]*>/g, ' ')
        
        // Decode HTML 
        const temp = document.createElement('div')
        temp.innerHTML = processed
        processed = temp.textContent || temp.innerText || ''
        
        return processed
    },
    countWords(text) {
        const plainText = this.stripHtml(text)
        if (!plainText || typeof plainText !== 'string') {
            return 0
        }

        // Normalize line breaks and paragraph separators to spaces
        let normalized = plainText.replace(/[\r\n\u2028\u2029]+/g, ' ')

        // Normalize ALL other whitespace characters to spaces
        normalized = normalized.replace(/[\s\u00A0\u2000-\u200B\uFEFF]+/g, ' ')

        normalized = normalized.trim()

        if (!normalized) {
            return 0
        }

        return normalized.split(' ').filter(word => word.length > 0).length
    },
    countCharacters(text) {
      const plainText = this.stripHtml(text)
      return plainText.length
    }
    },
    watch: {
        isOverLimit(newVal) {
            this.$emit("limit-exceeded", newVal);
        }
    }
  }
  </script>
  
  <style scoped>
  .text-danger {
    font-weight: bold;
  }
  </style>
  